import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const AfterPayClearPayOverlayBody = lazy(() => import('./AfterPayClearPayOverlayBody'/* webpackChunkName: 'AfterPayClearPayOverlayBody' */));

export default function AfterPayClearPayOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <AfterPayClearPayOverlayBody />
    </GenericFallbackSuspense>
  );
}
